import { getPaymentTypeKey } from 'src/pages/previewOrderPage/components/PaymentDetails';
import { PreviewOrderErrorType, PreviewOrderStatus } from 'src/pages/previewOrderPage/utils';
/** `read()`, or `fallback()` while a new key is untranslated (`getMessage` throws on a missing key). */
export const getMessageOrFallback = (read, fallback) => {
    try {
        return read();
    }
    catch (_a) {
        return fallback();
    }
};
/** The single item of a single-item order, or undefined when the response has none. */
export const getFirstOrderItem = (response) => {
    var _a, _b;
    const [order] = (_a = response === null || response === void 0 ? void 0 : response.orders) !== null && _a !== void 0 ? _a : [];
    const [item] = (_b = order === null || order === void 0 ? void 0 : order.items) !== null && _b !== void 0 ? _b : [];
    return item;
};
/** The 1-Click error to show for a verify outcome, or undefined while loading or on success. */
export const getVerifyError = (outcome) => {
    if (outcome === 'paymentError')
        return 'payment';
    if (outcome === 'unverified' || outcome === 'genericError')
        return 'generic';
    return undefined;
};
/** The order button's label key and action for a preview status, as on POP. */
export const getOrderAction = (status) => {
    if (status === PreviewOrderStatus.UNFIXABLE_ERROR)
        return { key: 'backToProduct', action: 'backToProduct' };
    if (status === PreviewOrderStatus.FIXABLE_ERROR)
        return { key: 'retry', action: 'retry' };
    return { key: 'placeYourOrder', action: 'place' };
};
/** The sheet's row labels and values as POP shows them; values are undefined only while the preview loads. */
export const getOrderDetails = (preview, errorType, bundle, popBundle, isLoading = false) => {
    const withFallback = (key, fallbackKey) => getMessageOrFallback(() => bundle.getMessage(key), () => popBundle.getMessage(fallbackKey));
    const labels = {
        shipToLabel: withFallback('shipTo', 'delivery'),
        payWithLabel: withFallback('payWith', 'payment'),
        totalLabel: withFallback('total', 'orderTotal'),
    };
    if (isLoading)
        return Object.assign(Object.assign({}, labels), { shipTo: undefined, payWith: undefined });
    // As on POP, any error or a missing value shows the section name instead
    const { shippingAddress, paymentMethod } = (errorType === PreviewOrderErrorType.NONE && preview) || {};
    let payWith = popBundle.getMessage('payment');
    if ((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === 'CARD') {
        payWith = getMessageOrFallback(() => bundle.formatMessage('cardWithLastDigits', { data: paymentMethod.tail }), () => popBundle.formatMessage('payingWithCard', { data: paymentMethod.tail }));
    }
    else if (paymentMethod) {
        payWith = popBundle.formatMessage(getPaymentTypeKey(paymentMethod.type), { data: paymentMethod.tail });
    }
    return Object.assign(Object.assign({}, labels), { shipTo: shippingAddress
            ? [shippingAddress.name, shippingAddress.addressLine1].filter(Boolean).join(', ')
            : popBundle.getMessage('delivery'), payWith });
};
